import React, { Component } from "react";
import Random from "another-random-package";
import {Link} from 'gatsby';
import "./imageWrapper.scss"

class ImageWrapper extends Component {
    sources;
    overlay;
    id = Random.randomStringAlphaNumericLower(23);
    style;
    componentDidMount() {
    }
    componentWillUnmount() {
        if (this.style !== undefined) {
            this.style.remove();
        }
    }
    render() {
        const hasSources = this.props?.config.sources || false;
        const hasLink = this.props?.config.link || false;
        const { name,overlay } = this.props.config;
        let hasOverlay = overlay ? "img-overlay" : "";
        let hasName = name ?? ""
        return (
            <div className={`img-wrapper ${this.props.config.size}`}>
                {hasLink && (
                    <Link
                        data-name={hasName}
                        className={hasOverlay}
                        to={`${this.props.config.link}`}
                    />
                )}
                <picture>
                    {hasSources &&
                    hasSources.forEach(source => (
                        <source srcSet={source} key={Random.randomStringAlphaNumeric(4)} />
                    ))}
                    {this.props.children}
                </picture>
            </div>
        );
    }
}

export default ImageWrapper;